import firebase from '@firebase/app';

export const updateExercise = (uidProfessor, uidExercise, exercise, callback) => {

  return firebase.firestore().collection("exercises")
    .doc(uidExercise)
    .update(exercise)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const registerExercise = (exercise, callback) => {
  exercise.date_request_accept = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("exercises").add(exercise)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const deleteExercise = (exercise, callback) => {

  return firebase.firestore().collection("exercises")
    .doc(exercise.id)
    .delete()
    .then(function () {
      console.log("Document successfully written!");
      callback(true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const exercisesList = (callback) => {


  return firebase.firestore().collection("exercises").orderBy("category", "asc")
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}

export const exercisesByCategoryList = (category, callback) => {
  return firebase.firestore().collection("exercises")
    .where("category", "==", category)
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}


// WEBPACK FOOTER //
// src/dao-firebase/exercise-firebase.js